import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const FormWrapper = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const InputsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 460px;
    width: 100%;
`;

export const InfoText = styled(Typography.TextBody_16_24)`
    margin: 24px 0;
    text-align: center;
`;

export const ReviewerInfoWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius['8']}px;
        display: flex;
        flex-direction: column;
        /* Always the form's last child - without a trailing margin the
         * panel that follows the form sits flush against this one. */
        margin-bottom: 16px;
        max-width: 460px;
        padding: 36px 32px 40px 32px;
        width: 100%;
    `,
);

export const ReviewerInfoText = styled(Typography.TextBody_16_24)`
    margin-top: 4px;
`;

export const ReviewerNameText = styled.span`
    font-weight: 700;
`;
